import { CommonSection } from '~/components/flp/Financing.styles';
import { Container, Divider } from './SocialProof.styles';
import Reviews from '../Reviews';
import SocialValue from '../SocialValue';

export default function SocialProof() {
  return (
    <CommonSection>
      <Container>
        <Reviews />
        <Divider />
        <SocialValue />
      </Container>
    </CommonSection>
  );
}
